<template lang="pug">
  CommonSection.b-project-list(:title="title" :back="archived ? { name: 'project-list', title: 'Вернуться к активным проектам' } : null")
    template(#button)
      ._header-btns
        Btn(round transparent xl :grey="!myProjectsFilter" :blue="myProjectsFilter" @click="myProjectsFilter = !myProjectsFilter")
          Icon(name="profile" :style="{ height: '20px', fill: myProjectsFilter ? '#33A1FB' : '#8B8CA9' }")
          | Мои проекты
        Btn(dark xl :to="{ name: 'project-create' }")
          Icon(name="plus")
          | Новый проект
    ._container(v-if="items && items.length")
      ._items
        ProjectTile._item(v-for="item in itemsFilteredSorted" :key="item['@id']" :project="item" :archived="archived" @archive="archive(item, $event)" @delete="remove(item)")
      BaseShowMore(v-if="total > items.length" :loading="loading" @click="loadNextPage")
      Btn(violent transparent v-if="!archived" :to="{ name: 'project-list-archived' }")._btn-archived Архивные проекты
    PageSlug(v-else tooltipText="Начните работу <br> с создания проекта")
      Btn(green :to="{ name: 'project-create' }") Создать проект
      Btn(violent transparent v-if="!archived" :to="{ name: 'project-list-archived' }") Архивные проекты
</template>

<script>
import api from '@/api/project';
import userFavorites from '@/model/userFavorites';

import CommonSection from '@/components/CommonSection.vue';
import ProjectTile from '@/components/ProjectTile.vue';
import BaseShowMore from '@/components/BaseShowMore.vue';
import PageSlug from '@/components/PageSlug.vue';

export default {
  name: 'ProjectList',
  components: { PageSlug, BaseShowMore, CommonSection, ProjectTile }, // eslint-disable-line
  props: {
    archived: Boolean,
  },
  data() {
    return {
      total: null,
      page: 0,
      items: [],
      myProjectsFilter: false,
      loading: false,
    };
  },
  computed: {
    favorites() { return userFavorites.getFavorites('project'); },
    title() { return this.archived ? 'Архивные проекты' : 'Проекты'; },
    itemsFiltered() {
      return this.myProjectsFilter
        ? this.items.filter(p => p.author['@id'] === this.$store.state.auth.user['@id'])
        : this.items;
    },
    itemsFilteredSorted() {
      return [...this.itemsFiltered].sort((a, b) => this.favorites.includes(b['@id']) - this.favorites.includes(a['@id']));
    },
  },
  created() {
    this.loadNextPage();
  },
  methods: {
    loadNextPage() {
      this.page += 1;
      this.loading = true;

      api.fetchList({ page: this.page, isArchived: this.archived }, true)
        .then((response) => {
          this.loading = false;
          this.items = [...this.items, ...response.items];
          this.total = response.total;
        });
    },
    async archive(project, isArchive) {
      if (isArchive && project.numberOfTasks > project.numberOfClosedTasks) {
        const res = await this.$confirm('В проекте есть открытые задачи. Вы уверены, что хотите отправить проект в архив? Работа в проекте будет невозможна.');

        if (!res) return;
      }

      api.archive(project.id, isArchive, true)
        .then(() => { this.items = this.items.filter((item) => item !== project); });
    },
    async remove(project) {
      if (await this.$confirm(`Вы действительно хотите удалить проект [${project.name}]?`)) {
        api.delete(project.id, true)
          .then(() => { this.items = this.items.filter((item) => item !== project); });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.my-projects-filter {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 29px;
  border: 1px solid #DEDFE0;
  border-radius: 51px;
  background: transparent;
  color: #B8C3CF;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  cursor: pointer;

  svg {
    height: 20px;
    fill: #B8C3CF;
  }
}

.project-list {
  &__header-btns {
    display: flex;
    gap: 36px;
  }

  &__container {
    display: flex;
    flex-direction: column;
    gap: 60px;
    padding-bottom: 60px;
  }

  &__items {
    display: grid;
    gap: 36px;
    grid-template-columns: repeat(12, 1fr);
  }

  &__item {
    padding: 32px;
    transition: box-shadow 0.3s;
    &:hover {
      box-shadow: 0 12px 24px rgba(0, 0, 0, 0.16);
    }
    .project-item__top {
      margin-bottom: 16px;
    }
  }

  &__btn-archived {
    align-self: flex-start;
  }

  @media (max-width: 1250px) {
    &__items {
      gap: 24px;
      grid-template-columns: repeat(8, 1fr);
    }
  }

  @media (max-width: 768px) {
    &__items {
      gap: 20px;
      grid-template-columns: repeat(4, 1fr);
    }
  }
}

</style>
